import { ViewField } from "@/components/dashboard/setting/profile/ProfileView";
import { getNestedValue } from "@/utils/helper/form";
import React from "react";
import { EmployeeSidebar } from "./EmployeeDetails";
import { SideBarContentHeader } from "@/common/ui/SideBar";
import { ExitEmployeeConfig } from "@/utils/constant/formConfig.constant";
import { useParams } from "react-router-dom";
import { useEmployeeInfo } from "@/services/employee.services";
import { OverviewSectionSkeleton } from "@/common/ui/Loader";

interface ExitDetailsProps {
  tab: EmployeeSidebar;
}
const ExitDetails: React.FC<ExitDetailsProps> = ({ tab }) => {
  const { employeeId } = useParams();
  const { isLoading, data } = useEmployeeInfo({ empId: employeeId, view_typ: tab.apiKey });

  if (isLoading) return <OverviewSectionSkeleton />;
  return (
    <div className="flex flex-col w-full h-full">
      {tab?.name && <SideBarContentHeader heading={tab.name} className="!p-4 !z-0 rounded-llg rounded-b-none" />}
      <div className="overflow-y-auto h-full">
        <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2 p-2">
          {ExitEmployeeConfig.sections.map((section: any) => {
            return section.widgets.map((widget: any) => {
              if (widget?.hideOnViewMode) return null;
              const prefillField = widget?.viewField || widget?.apiField || widget.field;
              const fieldValue = prefillField ? getNestedValue(data, prefillField) : undefined;
              return (
                <div className="px-3 py-2 overflow-hidden" key={widget.field}>
                  <ViewField fieldType={widget.widgetType} label={widget.label} value={fieldValue || "-"} viewType={widget?.viewType} field={widget.field} />
                </div>
              );
            });
          })}
        </div>
      </div>
    </div>
  );
};

export default ExitDetails;
